import "./Page.css";

import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import { Link } from "react-router";
import Spinner from "../components/spinner.react";
import Button from "../components/Button.react";
import InputWithError from "../components/inputWithError.react";

export default class Login extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
  }

  onFormSubmit = e => {
    e.preventDefault();
    const { actions, auth: { forms }, notificationSystem } = this.props;

    actions.login(forms.login.fields).then(({ error, payload }) => {
      if (error) {
        if (payload.errors && payload.errors.token) {
          actions.setFormField("auth", "login", "is2FA", true);
        }
        focusInvalidField(payload, this, "login");
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions.getCurrentUser().then(() => {});
        this.redirectAfterLogin();
      }
    });
  };

  redirectAfterLogin = () => {
    const { history, location } = this.props;
    //if (location.state && location.state.nextPathname)
    //history.replaceState(null, location.state.nextPathname);
    //else
    history.pushState(null, "/orders");
  };

  onEnable2FACheckbox = e => {
    const { actions, auth: { forms } } = this.props;

    if (forms.login.fields.is2FA) {
      actions.setFormField("auth", "login", "is2FA", false);
    } else {
      actions.setFormField("auth", "login", "is2FA", true);
    }
  };

  render() {
    const { actions, auth: { forms }, msg: { auth: msg } } = this.props;

    const loginFormProps = {
      feature: "auth",
      actions: actions,
      form: forms.login,
      formName: "login",
      msg: msg.forms.login,
      validateFormField: actions.validateFormFieldAuth
    };

    return (
      <div className="auth-page row center-xs middle-xs">
        <div className="col-xs-12 col-lg-3 auth-box">
          <h1>Fluct</h1>
          <h2>Fantastyczny. Nieprzęciętny. Wybitny.</h2>
          <form onSubmit={this.onFormSubmit} name="login" noValidate>
            <InputWithError
              field={"email"}
              placeholder="Wprowadź email"
              type="email"
              {...loginFormProps}
            />
            <InputWithError
              field={"password"}
              placeholder="Wprowadź hasło"
              type="password"
              {...loginFormProps}
            />
            {false && (
              <label htmlFor="is2FA" className="label">
                Używam podwójnego zabezpieczenia
              </label>
            )}
            {false && (
              <InputWithError
                field={"token"}
                type="number"
                placeholder="Wprowadź kod autentykacji"
                {...loginFormProps}
              />
            )}
            <hr />
            <Button
              text="Zaloguj się"
              success
              login
              disabled={forms.login.disabled || !isFormValid(forms.login)}
            />
            <div className="col-xs-12 center-xs">
              <Link to="/forgot">Zapomniałeś hasła?</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/auth/Login.react.js